export default __webpack_public_path__ + "static/media/content.9e526596.png";